require("fslightbox");
import "@babel/polyfill";
import "./polyfills";
import objectFitImages from "object-fit-images";
import homePage from "./pages/home";
import residentialCollections from "./pages/residentialCollections";
import payments from "./pages/payments";
import newsListingPage from "./pages/news-listing";
import newsPostPage from "./pages/news-post";
import aboutPage from "./pages/about";
import contactPage from "./pages/contact";
import careersPage from "./pages/careers";
import { electricVehicleLaunch } from "./pages/electric-vehicle-launch";
import search from "./components/search-new";
import nav from "./components/nav";
import modals from "./components/modals";
import accordions from "./components/accordions";
import { imageCarousel } from "./components/image-carousel";
import { imageCarouselBlock } from "./blocks/image-carousel";
import $ from "jquery";
import fitty from "fitty";
import backToTop from "./components/back-to-top";
import AOS from "aos";

import validation from "./components/validation";
import splitBannerQuote from "./components/split-banner-quote";
import quoteCTA from "./components/quoteCTA";
import accordionSplitImage from "./components/accordion-split-image";
import gatedDownload from "./blocks/gated-download";
import downloadableFileListGated from "./blocks/downloadable-file-list-gated";
import quoteButtonForm from "./components/quote-button-form";
import initPopupForm from "./blocks/popup-form";
import contact from "./blocks/contact";
import imageMarquee from "./blocks/image-marquee";
import servicesHero from "./blocks/services-hero";
import mediaTestimonials from "./blocks/media-testimonials";
import maxWidth from "./components/max-width";
import cookie from "./components/cookie";
import cardCarousel from "./blocks/card-carousel";
import staggeredGrid from "./blocks/staggered-grid";
import downloadCarousel from "./blocks/download-carousel";
import projectCarousel from "./blocks/project-carousel";
import timeline from "./blocks/timeline";
import banner from "./components/banner";
import glossary from "./blocks/glossary";
import facilityProcessCarousel from "./blocks/facility-process-carousel";
import twoColTicks from "./blocks/two-col-ticks";

document.addEventListener("alpine:init", () => {
	window.Alpine.data("validation", validation);
	window.Alpine.data("splitBannerQuote", splitBannerQuote);
	window.Alpine.data("quoteCTA", quoteCTA);
	window.Alpine.data("accordionSplitImage", accordionSplitImage);
	window.Alpine.data("gatedDownload", gatedDownload);
	window.Alpine.data("downloadableFileListGated", downloadableFileListGated);
	window.Alpine.data("quoteButtonForm", quoteButtonForm);
	window.Alpine.data("contact", contact);
	window.Alpine.data("imageMarquee", imageMarquee);
	window.Alpine.data("servicesHero", servicesHero);
	window.Alpine.data("mediaTestimonials", mediaTestimonials);
	window.Alpine.data("maxWidth", maxWidth);
	window.Alpine.data("cookie", cookie);
	window.Alpine.data("cardCarousel", cardCarousel);
	window.Alpine.data("staggeredGrid", staggeredGrid);
	window.Alpine.data("downloadCarousel", downloadCarousel);
	window.Alpine.data("projectCarousel", projectCarousel);
	window.Alpine.data("timeline", timeline);
	window.Alpine.data("banner", banner);
	window.Alpine.data("popupForm", initPopupForm);
	window.Alpine.data("glossary", glossary);
	window.Alpine.data("facilityProcessCarousel", facilityProcessCarousel);
	window.Alpine.data("twoColTicks", twoColTicks);
});

import { splitBanner } from "./blocks/split-banner";
import { FAQs } from "./blocks/faqs";
import { servicesCarousel } from "./blocks/services-carousel";
import { gallery } from "./blocks/gallery";
import { threeColumnPlan } from "./blocks/three-column-plan";
import { threeColumnStats } from "./blocks/three-column-stats";
import { quotePullout } from "./blocks/quote-pullout";
import { businessOwnersGuide } from "./blocks/business-owners-guide";
import { contentWithGrid } from "./blocks/content-with-grid";
import { homepageQuoteHeader } from "./blocks/homepage-quote-header";
import { numberedProcess } from "./blocks/numbered-process";
import { headingImage } from "./blocks/heading-image";
import { googleMaps } from "./blocks/google-maps";
import { testimonials } from "./blocks/testimonials";

/**
 * Functions to be called on all pages
 */
function callOnAllPages() {
	if (document.querySelector(".magnifying-glass")) {
		search();
	}

	if (
		document.querySelector(".header__nav") &&
		!document.querySelector(".residential-waste")
	) {
		nav();
	}

	modals();
	accordions();
	objectFitImages();
	$(".sidebar-email").each(function () {
		fitty(this, {
			maxSize: 18,
		});
	});
	backToTop();

	/**
	 * blocks
	 */
	splitBanner();
	FAQs();
	servicesCarousel();
	gallery();
	threeColumnPlan();
	threeColumnStats();
	contentWithGrid();
	quotePullout();
	businessOwnersGuide();
	electricVehicleLaunch();
	imageCarousel();
	imageCarouselBlock();
	homepageQuoteHeader();
	numberedProcess();
	headingImage();
	googleMaps();
	testimonials();
}

/**
 * Page specific functions to be called
 */
function callPageFunctions() {
	if (document.querySelector(".page--home")) return homePage();
	if (document.querySelector(".page--landing-page")) return homePage();
	if (document.querySelector(".residential-waste"))
		return residentialCollections();
	if (document.querySelector(".payments")) return payments();
	if (document.querySelector(".news-listing")) return newsListingPage();
	if (document.querySelector(".page--news-post")) return newsPostPage();
	if (document.querySelector(".page--about")) return aboutPage();
	if (document.querySelector(".page--contact")) return contactPage();
	if (
		document.querySelector(".page--careers") ||
		document.querySelector(".page--careers-detail")
	)
		return careersPage();
}

document.addEventListener("DOMContentLoaded", function init() {
	callOnAllPages();
	callPageFunctions();
	document.body.classList.remove("no-transition");

	AOS.init({
		offset: 200,
	});
});
